export const FUN_PACK_NOTIFICATION_EVENT_TYPES = [
  'RAID_STARTED',
  'RAID_ENRAGE_WARNING',
  'RAID_COMPLETED',
  'RAID_FAILED',
  'STREAK_WARNING',
  'ACHIEVEMENT_UNLOCKED',
  'COSMETIC_UNLOCKED',
] as const

export type FunPackNotificationEventType = (typeof FUN_PACK_NOTIFICATION_EVENT_TYPES)[number]

const FUN_PACK_EVENT_TYPE_SET: ReadonlySet<string> = new Set(FUN_PACK_NOTIFICATION_EVENT_TYPES)

export interface NotificationLike {
  eventType?: string | null
  category?: string | null
  workspaceId?: string | null
}

export interface FunPackNotificationContext {
  funPackOffWorkspaceIds: ReadonlySet<string>
  activeWorkspaceFunPackOff: boolean
}

export const isFunPackNotification = (n: {
  eventType?: string | null
  category?: string | null
}): boolean => {
  if (n.category === 'DIGEST' || n.eventType === 'DIGEST') {
    return false
  }
  if (n.eventType && FUN_PACK_EVENT_TYPE_SET.has(n.eventType)) {
    return true
  }
  if (n.category === 'GAMIFICATION') {
    return true
  }
  return false
}

export const hideFunPackNotification = (
  n: NotificationLike,
  ctx: FunPackNotificationContext,
): boolean => {
  if (!isFunPackNotification(n)) {
    return false
  }
  return n.workspaceId
    ? ctx.funPackOffWorkspaceIds.has(n.workspaceId)
    : ctx.activeWorkspaceFunPackOff
}
